module.exports = __webpack_public_path__ + "img/gb-eng.a99690fc.svg";